module.exports = __webpack_public_path__ + "assets/img/3.1ee11cc5.png";